import { render, staticRenderFns } from "./MintDialogWhitelist.vue?vue&type=template&id=a483f4cc&scoped=true&"
import script from "./MintDialogWhitelist.vue?vue&type=script&lang=js&"
export * from "./MintDialogWhitelist.vue?vue&type=script&lang=js&"
import style0 from "./MintDialogWhitelist.vue?vue&type=style&index=0&id=a483f4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a483f4cc",
  null
  
)

export default component.exports